import { render, staticRenderFns } from "./ImageCardNdvi.vue?vue&type=template&id=5783471a&scoped=true"
import script from "./ImageCardNdvi.vue?vue&type=script&lang=js"
export * from "./ImageCardNdvi.vue?vue&type=script&lang=js"
import style0 from "./ImageCardNdvi.vue?vue&type=style&index=0&id=5783471a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783471a",
  null
  
)

export default component.exports